export default __webpack_public_path__ + "static/media/home.9dffed16.svg";